import language from "./language";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import common_en from "./translations/en/common.json";
import common_fr from "./translations/fr/common.json";

import landing_en from "./translations/en/landing.json";
import landing_fr from "./translations/fr/landing.json";

import navigation_en from "./translations/en/navigation.json";
import navigation_fr from "./translations/fr/navigation.json";

import contact_info_en from "./translations/en/contact_info.json";
import contact_info_fr from "./translations/fr/contact_info.json";

import table_en from "./translations/en/table.json";
import table_fr from "./translations/fr/table.json";

import transition_en from "./translations/en/transition.json";
import transition_fr from "./translations/fr/transition.json";

import suite_breakdown_table_en from "./translations/en/suite_breakdown_table.json";
import suite_breakdown_table_fr from "./translations/fr/suite_breakdown_table.json";

import pie_en from "./translations/en/pie.json";
import pie_fr from "./translations/fr/pie.json";

import lease_table_en from "./translations/en/lease_table.json";
import lease_table_fr from "./translations/fr/lease_table.json";

import parking_property_en from "./translations/en/parking_property.json"
import parking_property_fr from "./translations/fr/parking_property.json"

import residential_parking_en from "./translations/en/residential_parking.json"
import residential_parking_fr from "./translations/fr/residential_parking.json"

import assisted_living_en from "./translations/en/assisted_living.json"
import assisted_living_fr from "./translations/fr/assisted_living.json"

import unit_en from "./translations/en/unit.json";
import unit_fr from "./translations/fr/unit.json";

import disclosure_en from "./translations/en/disclosure.json";
import disclosure_fr from "./translations/fr/disclosure.json";

import room_statistics_en from "./translations/en/room_statistics.json"
import room_statistics_fr from "./translations/fr/room_statistics.json"

import ltc_profile_attribute_en from "./translations/en/ltc_profile_attribute.json"
import ltc_profile_attribute_fr from "./translations/fr/ltc_profile_attribute.json"

import rounds_rate_en from "./translations/en/rounds_rate.json"
import rounds_rate_fr from "./translations/fr/rounds_rate.json"

import rent_inclusions_en from "./translations/en/rent_inclusions.json"
import rent_inclusions_fr from "./translations/fr/rent_inclusions.json"

import number_of_sites_en from "./translations/en/number_of_sites.json"
import number_of_sites_fr from "./translations/fr/number_of_sites.json"

import gev_en from "./translations/en/gev.json"
import gev_fr from "./translations/fr/gev.json"

import guided_wizard_en from "./translations/en/guided_wizard.json"
import guided_wizard_fr from "./translations/fr/guided_wizard.json"

import utilities_en from "./translations/en/utilities.json";
import utilities_fr from "./translations/fr/utilities.json";

import toc_en from "./translations/en/toc.json";
import toc_fr from "./translations/fr/toc.json";

import campaign_list_en from "./translations/en/campaign_list.json";
import campaign_list_fr from "./translations/fr/campaign_list.json";

import system_en from "./translations/en/system.json";
import system_fr from "./translations/fr/system.json";

import summary_en from "./translations/en/summary.json";
import summary_fr from "./translations/fr/summary.json";

import occupancy_statistics_en from "./translations/en/occupancy_statistics.json";
import occupancy_statistics_fr from "./translations/fr/occupancy_statistics.json";

import unit_table_en from "./translations/en/unit_table.json"
import unit_table_fr from "./translations/fr/unit_table.json"

import property_details_en from "./translations/en/property_details.json";
import property_details_fr from "./translations/fr/property_details.json";

import licensed_lands_en from "./translations/en/licensed_lands.json";
import licensed_lands_fr from "./translations/fr/licensed_lands.json";

import licensed_ponds_en from "./translations/en/licensed_ponds.json";
import licensed_ponds_fr from "./translations/fr/licensed_ponds.json";

import unlicensed_lands_en from "./translations/en/unlicensed_lands.json";
import unlicensed_lands_fr from "./translations/fr/unlicensed_lands.json";

import farm_conservation_managed_forest_land_en from "./translations/en/farm_conservation_managed_forest_land.json";
import farm_conservation_managed_forest_land_fr from "./translations/fr/farm_conservation_managed_forest_land.json";

import ags_summary_en from "./translations/en/ags_summary.json";
import ags_summary_fr from "./translations/fr/ags_summary.json";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        common: common_en,
        landing: landing_en,
        navigation: navigation_en,
        table: table_en,
        contact_info: contact_info_en,
        transition: transition_en,
        suite_breakdown_table: suite_breakdown_table_en,
        pie: pie_en,
        unit: unit_en,
        lease_table: lease_table_en,
        parking_property: parking_property_en,
        disclosure: disclosure_en,
        residential_parking: residential_parking_en,
        assisted_living: assisted_living_en,
        room_statistics: room_statistics_en,
        rent_inclusions: rent_inclusions_en,
        rounds_rate: rounds_rate_en,
        ltc_profile_attribute: ltc_profile_attribute_en,
        number_of_sites: number_of_sites_en,
        gev: gev_en,
        utilities: utilities_en,
        guided_wizard: guided_wizard_en,
        toc: toc_en,
        campaign_list: campaign_list_en,
        system: system_en,
        summary: summary_en,
        occupancy_statistics: occupancy_statistics_en,
        unit_table: unit_table_en,
        property_details: property_details_en,
        licensed_lands: licensed_lands_en,
        licensed_ponds: licensed_ponds_en,
        unlicensed_lands: unlicensed_lands_en,
        farm_conservation_managed_forest_land: farm_conservation_managed_forest_land_en,
        ags_summary: ags_summary_en
      },
      fr: {
        common: common_fr,
        landing: landing_fr,
        navigation: navigation_fr,
        table: table_fr,
        contact_info: contact_info_fr,
        transition: transition_fr,
        suite_breakdown_table: suite_breakdown_table_fr,
        pie: pie_fr,
        unit: unit_fr,
        lease_table: lease_table_fr,
        parking_property: parking_property_fr,
        disclosure: disclosure_fr,
        residential_parking: residential_parking_fr,
        assisted_living: assisted_living_fr,
        room_statistics: room_statistics_fr,
        rent_inclusions: rent_inclusions_fr,
        rounds_rate: rounds_rate_fr,
        ltc_profile_attribute: ltc_profile_attribute_fr,
        number_of_sites: number_of_sites_fr,
        gev: gev_fr,
        utilities: utilities_fr,
        guided_wizard: guided_wizard_fr,
        toc: toc_fr,
        campaign_list: campaign_list_fr,
        system: system_fr,
        summary: summary_fr,
        occupancy_statistics: occupancy_statistics_fr,
        unit_table: unit_table_fr,
        property_details: property_details_fr,
        licensed_lands: licensed_lands_fr,
        licensed_ponds: licensed_ponds_fr,
        unlicensed_lands: unlicensed_lands_fr,
        farm_conservation_managed_forest_land: farm_conservation_managed_forest_land_fr,
        ags_summary: ags_summary_fr
      }
    },
    lng: language || "en",
    fallbackLng: "en",
    supportedLngs: ["en", "fr"],
    interpolation: {
      escapeValue: false, // react already safes from xss
    }
  });

export default i18n;